import { useSelector } from "react-redux";
import { Button } from "@progress/kendo-react-buttons";
import { Slide, Push, Expand, Fade, Zoom, Reveal } from "@progress/kendo-react-animation";

export const Form = props => {
    const {
        className,
        toolbarRenderer, 
        hideToolbar = false,
        errorMessages, errorsDuration, onErrorbarClose,
        contentRenderer,
        children,
        ...other } = props;

    const currentTheme = useSelector(state => state.currentTheme);

    const errorBar = errorMessages && errorMessages.length > 0 ? 
        (
            <div className="errorbar">
                <ul>
                    {
                        errorMessages.map((error, index) => (<li key={index}>{error}</li>))
                    }
                </ul>
                <Button  style={{border: "none"}} icon="close" onClick={props.onErrorbarClose}></Button>
            </div>
        ) : null;

    let animation = <Reveal>{errorBar}</Reveal>;

    return (
        <div className={`form-root ${className}`}>
            {!hideToolbar && (
                <div className="toolbar">
                {
                    toolbarRenderer(props)
                }
                </div>
            )}
            {
                animation
            }
            <div className="content">
            {
                props.children
            }
            </div>
            <style>
                {
                    `
                        .form-root
                        {
                            display: flex;
                            flex-direction: column;
                            height:100%;
                            overflow: hidden;
                        }


                        /*toolbar*/
                        .form-root > .toolbar
                        {
                            flex-grow: 0;
                            flex-shrink: 0;                                
                        }

                        .form-root > .toolbar .k-toolbar
                        {
                            padding : 3px 4px 2px 0px;                            
                            background-color: transparent;
                        }

                        .form-root > .toolbar .k-toolbar .k-separator 
                        {
                            border-color: ${currentTheme.primary};
                        }

                        .form-root > .toolbar .k-toolbar .k-button
                        {
                            padding: 4px 4px;
                            background-color: transparent;                            
                        }

                        .form-root > .toolbar .k-toolbar .k-split-button:focus, .form-root .toolbar .k-toolbar .k-split-button.k-focus,
                        .form-root > .toolbar .k-toolbar .k-button-solid-base:focus, .form-root .toolbar .k-toolbar .k-button-solid-base.k-focus
                        {
                            box-shadow: none !important;
                            border: none !important;
                        }

                        .form-root > .toolbar .k-toolbar .k-button:active::before, .form-root > .toolbar .k-toolbar .k-button:hover::before,
                        .form-root > .toolbar .k-toolbar .k-button:focus::before, .form-root > .toolbar .k-toolbar .k-button:focus-within::before                        
                        {
                            opacity: 0 !important;
                            border: none !important;
                            box-shadow: none !important;
                        }

                        .form-toolbar > .k-toolbar .k-dropdown-button.k-focus .k-button::after
                        {
                            /*border: 1px solid ${currentTheme.componentBg} !important;*/
                            box-shadow: none !important;
                        }                       

                        .form-root > .toolbar .k-toolbar .k-button .k-button-text
                        {               
                            color: ${currentTheme.toolbarText};            
                        }
                        
                        .form-root > .toolbar .k-toolbar .k-button:hover .k-button-text
                        {
                        }


                        /*errorbar*/
                        .form-root .errorbar
                        {
                            color: ${currentTheme.error};
                            background-color: ${currentTheme.componentBg};
                            border-bottom: 1px solid ${currentTheme.separatorColor};
                            margin-bottom: 0;
                            display: flex;
                        }

                        .form-root .errorbar ul
                        {
                            margin: 4px 0;
                            flex: 1;
                            padding-left: 30px;
                        }

                        .form-root .errorbar li
                        {
                            list-style: circle;
                            font-size: 14px;
                            margin: 8px 0;
                        }

                        .form-root > .errorbar .k-button
                        {
                            background-color: transparent;/*${currentTheme.error};*/
                            color: ${currentTheme.error};
                            margin: 1px;
                            /*align-self: center;*/
                        }


                        /*content*/
                        .form-root > .content
                        {
                            display: flex;
                            flex-direction: column;
                            flex: 1;
                            overflow: auto;
                            height: 100%;
                        }
                       
                        .form-root .k-form .k-form-field
                        {
                            margin-top: 26px;
                        }

                        .form-root .k-form .k-label
                        {
                            font-size: 13px;
                            margin-bottom: 3px;
                            color: ${currentTheme.inputLabelColor};
                        }

                        /*formatting inputs and drop down lists to make them thicker/thiner*/
                        .form-root .k-form .k-input, .k-form .k-dropdownlist
                        {                        
                            border-left: 3px solid ${currentTheme.primary};
                        }

                        .form-root .k-form .k-input, .k-form .k-dropdownlist .k-input-inner
                        {
                            background-color: ${currentTheme.componentBg};
                        }

                        .form-root .k-form .k-input
                        {
                        }

                        .form-root .k-dropdownlist button
                        {
                        }

                        .form-root .k-dropdownlist .k-input-inner
                        {
                        }

                        .form-root .k-form .k-input.k-invalid, .form-root .k-form .k-dropdownlist.k-invalid
                        {
                            border-top-color: ${currentTheme.componentBorderColor};
                            border-bottom-color: ${currentTheme.componentBorderColor};
                            border-right-color: ${currentTheme.componentBorderColor};
                        }

                        .form-root .k-form .k-input:focus, .form-root .k-form .k-input.k-textarea:focus, .form-root .k-form .k-input.k-textarea:active, .form-root .k-form .k-dropdownlist:focus
                        {
                            box-shadow: none !important;
                            outline: none !important;
                        }

                        .form-root .k-form .k-input-solid:focus-within
                        {
                            box-shadow: none;
                        }
                    `
                }
            </style>
        </div>
    );
};
